/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PasskeySignal interface.
 */
export function instanceOfPasskeySignal(value) {
    if (!('rpId' in value) || value['rpId'] === undefined)
        return false;
    if (!('userHandle' in value) || value['userHandle'] === undefined)
        return false;
    if (!('remainingCredentialIds' in value) || value['remainingCredentialIds'] === undefined)
        return false;
    return true;
}
export function PasskeySignalFromJSON(json) {
    return PasskeySignalFromJSONTyped(json, false);
}
export function PasskeySignalFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rpId': json['rp_id'],
        'userHandle': json['user_handle'],
        'remainingCredentialIds': json['remaining_credential_ids'],
    };
}
export function PasskeySignalToJSON(json) {
    return PasskeySignalToJSONTyped(json, false);
}
export function PasskeySignalToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rp_id': value['rpId'],
        'user_handle': value['userHandle'],
        'remaining_credential_ids': value['remainingCredentialIds'],
    };
}
